import { makeRequestAuth } from "../utils/globals";

class TransactionServices {
  /* 
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
                                    Xoxo Link Related Services
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
    */

  /*
   * @Description : cancel voucher code
   * @input : voucher id
   * @returns{promise}
   */
  xoxoLinkBulkProcess = (link_data) => {
    return new Promise((resolve, reject) => {
      const queryData = {
        query: "storesAdmin.query.generateXoxoLinkBulk",
        tag: "storeAdmin",
        variables: {
          link_data: {
            ...link_data,
          },
        },
      };
      makeRequestAuth(queryData, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  /*
   * @param  filters
   * @returns {promise}
   * returns details of template based on given template id
   */
  getTemplateDetails = (params) => {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.mutation.get_template_details",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  getWhatsappTemplateDetail = (params) => {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.mutation.get_whatsapp_template_details",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  /*
   * @param  filters
   * @returns {promise}
   * returns details of template based on given template id
   */
  getCardImages = (params) => {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.query.template_fetch_album",
        tag: "storeAdmin",
        variables: {
          cat_data: {
            ...params,
          },
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  /*
   * @param  filters
   * @returns {promise}
   * returns details of sms
   */
  getSmsDetails = (params) => {
    return new Promise((resolve, reject) => {
      const request_data = {
        query: "storesAdmin.mutation.get_sms_details",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(request_data, (response) => {
        if (response && response.data) {
          resolve(response.data);
        } else {
          resolve({});
        }
      });
    });
  };

  generateLink(params) {
    return new Promise((resolve, reject) => {
      const getLink = {
        query: "storesAdmin.query.getGenerateLinks",
        tag: "storeAdmin",
        variables: {
          link_data: {
            campaignId: params.campaignId,
            linksCount: params.linksCount,
            method: params.method,
          },
        },
      };
      makeRequestAuth(getLink, (response) => {
        if (
          response &&
          response.data &&
          response.data.getGenerateLinks &&
          response.data.getGenerateLinks.success
        ) {
          resolve(response.data.getGenerateLinks);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  }

  getGenerateLinksNew(params) {
    return new Promise((resolve, reject) => {
      const getLink = {
        query: "storesAdmin.query.getGenerateLinksNew",
        tag: "storeAdmin",
        variables: {
          link_data: params,
        },
      };
      makeRequestAuth(getLink, (response) => {
        if (
          response &&
          response.data &&
          response.data.getGenerateLinksNew &&
          response.data.getGenerateLinksNew
        ) {
          resolve(response.data.getGenerateLinksNew);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  }

  fetchCampaignData = (params) => {
    return new Promise((resolve, reject) => {
      const getCamp = {
        query: "storesAdmin.query.getCampaignDetails",
        tag: "storeAdmin",
        variables: {
          camp_data: params,
        },
      };
      makeRequestAuth(getCamp, (response) => {
        if (
          response &&
          response.data &&
          response.data.getCampaignDetails &&
          response.data.getCampaignDetails.success
        ) {
          resolve(response.data.getCampaignDetails);
        } else {
          resolve({ Message: "Something went wrong", success: 0 });
        }
      });
    });
  };

  fetchOneClickCampaignSites(params) {
    return new Promise((resolve, reject) => {
      const getsites = {
        query: "storesAdmin.query.getOneClickSiteList",
        tag: "storeAdmin",
        variables: {
          add_data: params,
        },
      };
      makeRequestAuth(
        getsites,
        function (response) {
          if (
            response &&
            response.data &&
            response.data.getOneClickSiteList &&
            response.data.getOneClickSiteList.success
          ) {
            resolve(response.data.getOneClickSiteList);
          } else if (
            response &&
            response.data &&
            response.data.getOneClickSiteList &&
            !response.data.getOneClickSiteList.success &&
            response.data.getOneClickSiteList.errors
          ) {
            resolve(response.data.getOneClickSiteList);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        }.bind(this)
      );
    });
  }

  siteAvailable = (siteName) => {
    return new Promise((resolve, reject) => {
      const getsites = {
        query: "storesAdmin.query.siteAvailable",
        tag: "storeAdmin",
        variables: {
          campaignName: siteName,
        },
      };
      makeRequestAuth(
        getsites,
        function (response) {
          if (response && response.data && response.data.siteAvailable) {
            resolve(response.data.siteAvailable);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        }.bind(this)
      );
    });
  };

  linkSiteAvailable = (siteName) => {
    return new Promise((resolve, reject) => {
      const getsites = {
        query: "storesAdmin.query.linkSiteAvailable",
        tag: "storeAdmin",
        variables: {
          campaignName: siteName,
        },
      };
      makeRequestAuth(
        getsites,
        function (response) {
          if (response && response.data && response.data.linkSiteAvailable) {
            resolve(response.data.linkSiteAvailable);
          } else {
            resolve({ Message: "Something went wrong", success: 0 });
          }
        }.bind(this)
      );
    });
  };

  /* 
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
                                    Xoxo Link Related Services
    ==========================================================================================================================
    ==========================================================================================================================
    ==========================================================================================================================
    */
}

export default Object.freeze(new TransactionServices());
